const DAYS_IN_WEEK = 7;
const RAW_DAYS_UNTIL_NEXT_MONDAY = 8;
export const calculateDaysUntilNextWeek = (today = new Date()) => {
    const dayInTheWeek = today.getDay();
    return (RAW_DAYS_UNTIL_NEXT_MONDAY - dayInTheWeek) % DAYS_IN_WEEK || DAYS_IN_WEEK;
};
//# sourceMappingURL=calculateDaysUntilNextWeek.js.map